import React from "react";

export const startModal = () => ({
  title: "Welcome to Math Blitz!",
  description: (
    <div className="modal-description-body">
      <div className="modal-description-title">20 Questions. 90 Seconds.</div>
      <div className="modal-description-contents">
        <p>
          Solve as many problems as you can. You’ll get <strong>+10</strong> for
          each correct answer, <strong>−2</strong> for each wrong one, and a{" "}
          <strong>time bonus</strong> based on seconds left!
          <p>
            You can submit early to earn the time bonus, but only if you’ve
            answered all questions.
          </p>
        </p>
      </div>
      <div className="modal-description-footer">
        Ready to challenge your brain under pressure?
      </div>
    </div>
  ),
  buttonText: "Start",
  buttonType: "start",
});

export const endModal = (correct, wrong, timer, total) => ({
  title: "Your Score",
  description: (
    <div className="modal-description-body">
      <div className="modal-description-title" />
      <div className="modal-description-contents">
        <p>
          ✅ Correct: {correct} × 10 = {correct * 10}
        </p>
        <p>
          ❌ Wrong: {wrong} × −2 = {wrong * -2}
        </p>
        <p>⏱️ Time Bonus: {timer}</p>
        <br />
        <p>
          🧮 <strong>Total Score: {total}</strong>
        </p>
      </div>
    </div>
  ),
  buttonText: "View Answers",
  buttonType: "start",
});
